import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 20 10" {...props}>
      <path d="M15.9775 0.29632C15.6355 0.28304 15.3176 0.478916 15.1774 0.79182C15.0354 1.10472 15.0968 1.47075 15.3342 1.7214L17.9246 4.52093H1.61959C1.31499 4.51595 1.03279 4.67531 0.880077 4.93924C0.72487 5.20069 0.72487 5.52687 0.880077 5.78831C1.03279 6.05225 1.31499 6.21161 1.61959 6.20663H17.9246L15.3342 9.00616C15.1234 9.22693 15.0487 9.54315 15.1383 9.83448C15.2272 10.1266 15.4654 10.3466 15.7617 10.413C16.0605 10.4785 16.37 10.3781 16.5726 10.1524L21.0005 5.36336L16.5726 0.575194C16.4207 0.406708 16.2049 0.30462 15.9775 0.29632Z" />
    </Svg>
  );
};

export default Icon;
